import { Worksheet } from "./calculator";

export const scopePlaceholders = [
  { label: "Selling quantity", token: "{{selling_quantity}}" },
  { label: "Unit", token: "{{unit}}" },
];

export function renderWorksheetScope(item: Pick<Worksheet, "scope" | "quantity" | "unit">) {
  let quantity = item.quantity;
  const match = /^(\d*)(?:\.(\d*))?$/.exec(quantity);
  if (match && quantity !== "" && quantity !== ".") {
    const whole = (match[1].replace(/^0+/, "") || "0").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const fraction = (match[2] ?? "").replace(/0+$/, "");
    quantity = whole + (fraction ? `.${fraction}` : "");
  }
  return (item.scope ?? "").replace(/\{\{(selling_quantity|unit)\}\}/g, (_, key) =>
    key === "selling_quantity" ? quantity : item.unit
  );
}

export const escapeScopeText = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
export function sanitizeWorksheetHtml(value: string): string {
  const doc = new DOMParser().parseFromString(value, "text/html");
  const visit = (node: Node): string => {
    if (node.nodeType === 3) return escapeScopeText(node.textContent ?? "");
    if (node.nodeType !== 1) return "";
    const tag = (node as Element).tagName.toLowerCase();
    if (["script", "style", "iframe", "object", "svg", "math"].includes(tag)) return "";
    const children = Array.from(node.childNodes).map(visit).join("");
    if (tag === "br") return "<br>";
    const allowed = {
      b: "strong",
      i: "em",
      strong: "strong",
      em: "em",
      p: "p",
      ul: "ul",
      li: "li",
    } as Record<string, string>;
    return allowed[tag] ? `<${allowed[tag]}>${children}</${allowed[tag]}>` : children;
  };
  return Array.from(doc.body.childNodes).map(visit).join("");
}
export function worksheetScopeEditorHtml(value: string, format?: string | null) {
  return format === "html"
    ? sanitizeWorksheetHtml(value)
    : `<p>${escapeScopeText(value).replace(/\r?\n/g, "<br>")}</p>`;
}
export function renderWorksheetScopeHtml(
  item: Pick<Worksheet, "scope" | "scopeFormat" | "quantity" | "unit">
) {
  const html = worksheetScopeEditorHtml(item.scope ?? "", item.scopeFormat);
  return renderWorksheetScope({
    ...item,
    scope: html,
    unit: escapeScopeText(item.unit),
    quantity: escapeScopeText(item.quantity),
  });
}
